module.exports = __webpack_public_path__ + "static/home_story_photo-404ecbbd5c8b59231c9eada65c703c81.jpg";